import { render, staticRenderFns } from "./MerchantNo.vue?vue&type=template&id=3d64364b&scoped=true"
import script from "./MerchantNo.vue?vue&type=script&lang=js"
export * from "./MerchantNo.vue?vue&type=script&lang=js"
import style0 from "./MerchantNo.vue?vue&type=style&index=0&id=3d64364b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d64364b",
  null
  
)

export default component.exports